import component from './selectProject.vue'

export default component
